import * as Styles from "../../../styles.ts";
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { sendNowhere } from "../../view.ts";
import { TemplateResult } from "lit/html.js";
import { isEmpty } from "../../../../util/text.ts";

// Components
import "../../dui/page-inset/dui-page-inset.ts";
import "../../dui/markdown/dui-markdown.ts";
import "../loading.ts";

const style = css`
  :host {
    display: block;
    height: 100cqh;
    width: 100cqw;
    container-type: size;
  }
`;

const ReportView = (report: string): TemplateResult => {
  if (isEmpty(report)) {
    return html` <loading-view></loading-view> `;
  } else {
    return html`
      <dui-page-inset>
        <dui-markdown .value="${report}"></dui-markdown>
      </dui-page-inset>
    `;
  }
};

@customElement("report-panel")
export class ReportPanelElement extends LitElement {
  static override styles = [Styles.base, style];

  @property({ type: String })
  accessor report = "";

  send = sendNowhere;

  override render() {
    return html` ${ReportView(this.report)} `;
  }
}
